import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Styles from './Label.module.scss';

export const Label = ({ name, error, children }) => (
  <label
    className={classnames(Styles['label'], {
      [Styles['error']]: error
    })}
    htmlFor={name}
  >
    {children}
  </label>
);

Label.propTypes = {
  name: PropTypes.string,
  children: PropTypes.any,
  error: PropTypes.string
};

export default Label;
